import { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, get, errMsg } from "@/lib/api";

export const useMeta = () => useQuery({ queryKey: ["admin-meta"], queryFn: () => get("/admin/meta"), staleTime: Infinity });
export const useAdminCategories = () => useQuery({ queryKey: ["admin-categories"], queryFn: () => get("/admin/categories") });
export const useSources = () => useQuery({ queryKey: ["sources"], queryFn: () => get("/admin/sources") });
export const useAutomations = () => useQuery({ queryKey: ["automations"], queryFn: () => get("/admin/automations") });

const KEYS = ["stats", "admin-articles", "automations", "runs", "admin-categories", "sources", "home", "layout", "feed", "admin-pages", "page", "admin-settings", "admin-tracking"];

export const useRefresh = () => {
  const qc = useQueryClient();
  return () => KEYS.forEach((k) => qc.invalidateQueries({ queryKey: [k] }));
};

export const useAutomationActions = () => {
  const refresh = useRefresh();
  const [runId, setRunId] = useState(null);
  const toggle = useMutation({
    mutationFn: (a) => api.put(`/admin/automations/${a.id}`, { ...a, enabled: !a.enabled }),
    onSuccess: (_, a) => {
      toast.success(a.enabled ? "Automatización en pausa" : "Automatización activada");
      refresh();
    },
    onError: (e) => toast.error(errMsg(e)),
  });
  const run = useMutation({
    mutationFn: (a) => api.post(`/admin/automations/${a.id}/run`).then((r) => r.data),
    onSuccess: (r) => setRunId(r.id),
    onError: (e) => toast.error(errMsg(e)),
  });
  return { toggle, run, runId, setRunId };
};
